import _asyncToGenerator from "/builds/vtblife/frontend/common/gatsby-party/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _slicedToArray from "/builds/vtblife/frontend/common/gatsby-party/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import _regeneratorRuntime from "/builds/vtblife/frontend/common/gatsby-party/node_modules/@babel/runtime/regenerator/index.js";
import React, { useEffect, useState } from 'react';
import shuffle from 'lodash/shuffle';
import { Spinner } from '@vtblife/uikit';
import { getQuizProps } from '../../utils/get-quiz-props';
import { QuizModalLayout } from '../quiz-modal/components/quiz-modal-layout/quiz-modal-layout';
import { QuizModal } from '../quiz-modal/quiz-modal';
var quizCache = {};
export var Quiz = function Quiz(props) {
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    isOpenLoader = _useState2[0],
    setIsOpenLoader = _useState2[1];
  var _useState3 = useState(null),
    _useState4 = _slicedToArray(_useState3, 2),
    quizProps = _useState4[0],
    setQuizProps = _useState4[1];
  var id = props.id,
    _props$background = props.background,
    background = _props$background === void 0 ? 'transparent' : _props$background,
    _props$layout = props.layout,
    layout = _props$layout === void 0 ? '8c' : _props$layout,
    isOpen = props.isOpen,
    onClose = props.onClose,
    _props$environment = props.environment,
    environment = _props$environment === void 0 ? 'production' : _props$environment;
  useEffect(function () {
    if (!id) return;
    if (quizCache[id]) {
      setQuizProps(quizCache[id]);
      return;
    }
    setIsOpenLoader(true);
    var fetchQuizProps = /*#__PURE__*/function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var _a, data;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.prev = 0;
              _context.next = 3;
              return getQuizProps({
                id: id,
                environment: environment
              });
            case 3:
              data = _context.sent;
              // Перемешивание вариантов ответа
              (_a = data.steps) === null || _a === void 0 ? void 0 : _a.forEach(function (step) {
                var _a;
                if ((_a = step.field) === null || _a === void 0 ? void 0 : _a.shuffleOptions) {
                  step.field.options = shuffle(step.field.options);
                }
              });
              quizCache[id] = data;
              setQuizProps(data);
              _context.next = 12;
              break;
            case 9:
              _context.prev = 9;
              _context.t0 = _context["catch"](0);
              console.error("\u041E\u0448\u0438\u0431\u043A\u0430 \u043F\u0440\u0438 \u0437\u0430\u0433\u0440\u0443\u0437\u043A\u0435 \u043F\u0440\u043E\u043F\u0441\u043E\u0432 \u043A\u0432\u0438\u0437\u0430 \u0441 id ".concat(id, ":"), _context.t0);
            case 12:
              _context.prev = 12;
              setIsOpenLoader(false);
              return _context.finish(12);
            case 15:
            case "end":
              return _context.stop();
          }
        }, _callee, null, [[0, 9, 12, 15]]);
      }));
      return function fetchQuizProps() {
        return _ref.apply(this, arguments);
      };
    }();
    fetchQuizProps();
  }, [id, environment]);
  if (isOpenLoader) {
    return React.createElement(QuizModalLayout, {
      background: background,
      layout: layout,
      onClose: onClose,
      open: isOpen
    }, React.createElement("div", {
      style: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        height: '100%'
      }
    }, React.createElement(Spinner, null)));
  }
  return quizProps ? React.createElement(QuizModal, {
    isOpen: isOpen,
    onClose: onClose,
    settings: quizProps
  }) : null;
};